<template>
    <div class="container-ranking">
        <div class="container mt-5">
            <div class="row justify-content-center">
                <div class="col-12 col-md-10 col-lg-8">
                    <h2 class="text-center title-ranking mb-4">Ranking desinformador</h2>
                    <p>
    
                    </p>
                </div>
                <div class="col-12 col-md-10 col-lg-10">
                    <div class="ranking-list">
                        <div v-for="(item, index) in ranking.slice(0,5)" :key="index" class="mb-3 pb-3 item-ranking">
                                <div class="row">
                                    <div class="col-12 text-left">
                                        <div class="">
                                            <div class="mb-3">
                                                <span class="circle-number">{{ index + 1 }}</span>
                                                 <a class="sitename" href="#" target="_blank"><img  :src="item.logo" alt="Logo del medio" class="logo" />
                                                {{ item.medio }}</a> <span class="date">| Publicado: {{ item.fecha }} |</span> <a class="date" v-if="item.enlace" :href="item.enlace" target="_blank"> 
                                                    Ver publicación
                                                </a> 
                                            </div>
                                            <div class="statement mb-2">
                                                "{{ item.desinformacion }}"
                                            </div>
                                            <div class="context">
                                                <b>Contexto:</b>
                                                    {{ item.tema }} | 
                                                <a v-if="item.verificacion[0]" :href="item.verificacion[0]" target="_blank">Ver verificación</a>
                                                <a v-if="item.verificacion[1]" :href="item.verificacion[1]" target="_blank"> | Ver verificación 2</a>
                                            </div>
                                        </div>
                               
                                    </div>
                                </div>
                        </div>
                    </div>

                    <div class="collapse" id="collapseRanking">
                        <div class="ranking-list">
                            <div v-for="(item, index) in ranking.slice(5)" :key="index" class="mb-3 pb-3 item-ranking">
                                    <div class="row">
                                        <div class="col-12 text-left">
                                            <div class="">
                                                <div class="mb-3">
                                                    <span class="circle-number">{{ index + 6 }}</span>
                                                     <a class="sitename" href="#" target="_blank"><img  :src="item.logo" alt="Logo del medio" class="logo" />
                                                    {{ item.medio }}</a> <span class="date">| Publicado: {{ item.fecha }} |</span> <a class="date" v-if="item.enlace" :href="item.enlace" target="_blank">
                                                            Ver publicación
                                                    </a> 
                                                </div>
                                                <div class="statement mb-2">
                                                    "{{ item.desinformacion }}"
                                                </div>
                                                <div class="context">
                                                    <b>Contexto:</b>
                                                        {{ item.tema }} | 
                                                    
                                                        <a v-if="item.verificacion[0]" :href="item.verificacion[0]" target="_blank">Ver verificación</a>
                                                        <a v-if="item.verificacion[1]" :href="item.verificacion[1]" target="_blank"> | Ver verificación 2</a>
                                                </div>
                                            </div>
                                   
                                        </div>
                                    </div>
                            </div>
                        </div>
                      </div>

                      <button class="btn btn-danger" type="button" data-toggle="collapse" data-target="#collapseRanking" aria-expanded="false" aria-controls="collapseRanking">
                        Ver lista completa
                      </button>
                      
                </div>
            </div>
        </div>
    </div>
</template>

<style>
    h2.title-ranking {
        font-size: 31px;
        color: #fff;
        font-family: "Fira Sans",sans-serif;
    }

    .ranking-list {
        text-align: left;
        

        .statement {
            font-size: 16px;
            font-weight: 600;
            font-family: "Lora";   
        }

        .item-ranking {
            font-family: "Noto Sans";
            background-color: #000000bd;
            padding: 15px;
        }
        
        a.sitename {
            color: #fff;
            border-radius: 23px;
            padding: 0px 10px 0px 0;
            background-color: #e41b1d;
            text-decoration: none;
            font-size: 14px;
            vertical-align: middle;
            display: inline-block;
        }

        .date {
            font-size: 14px;
            color: #e3e3e3;
        }
        
        .logo {
            width: 30px;
        }

        .context {
            font-size: 16px;
            color: #e3e3e3
        }

        .circle-number {
            font-weight: 600;
            color: #333 !important;
            display: inline-block;
            background-color: #fff;
            border-radius: 50%;
            width: 30px;
            height: 30px;
            padding: 5px;
            color: #fff;
            font-size: 15px;
            text-align: center;
            margin-right: 5px;
        }
    }


    .container-ranking {
        padding: 25px 0;
        background-color: #333;
        color: #fff;
        background-image: url('../assets/bg-ranking.png');
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        background-attachment: fixed;
        background-blend-mode: lighten;

        span {
            color: #e3e3e3;
        }
    }
</style>

<script>

export default {
  name: 'Ranking',
  data: function() {
            return {
                ranking: [
                    {
                        medio: 'El Reporte',
                        logo: '/wp-content/interactivos/el-cartel-de-la-desinformacion/logos/el-reporte.png',
                        desinformacion: 'Los manifestantes contra Dina Boluarte son terroristas',
                        tema: 'Protestas contra el gobierno de Dina Boluarte entre diciembre de 2022 y marzo de 2023',
                        enlace: 'https://elreporte.pe/2023/01/05/llamalo-por-su-nombre-terrorismo-por-diego-gutierrez',
                        fecha: '5/01/2023',
                        verificacion: ['https://www.infobae.com/peru/2023/05/18/relator-de-onu-sobre-protestas-que-dejaron-mas-de-60-muertes-no-hay-evidencias-de-que-manifestantes-eran-terroristas/']                            
                    },
                    {
                        medio: 'Willax TV',
                        logo: '/wp-content/interactivos/el-cartel-de-la-desinformacion/logos/willax.png',
                        desinformacion: 'Las turbas violentas y no la Policía Nacional del Perú habrían ocasionado la muerte de los jóvenes manifestantes Inti Sotelo y Bryan Pintado el 14 de noviembre de 2020  ',
                        tema: 'Circunstancias de las muertes de Inti Sotelo y Bryan Pintado ',
                        enlace: 'https://www.expreso.com.pe/judicial/fiscalia-acusa-a-flores-araoz-y-gaston-rodriguez-sin-ninguna-investigacion-o-pericia-probada/748748/',
                        fecha: '8/11/2021',
                        verificacion: ['https://www.idl-reporteros.pe/la-muerte-de-inti/',
                                        'https://www.gob.pe/institucion/mpfn/noticias/542907-ministerio-publico-formaliza-denuncia-penal-contra-altos-mandos-y-oficiales-pnp-por-homicidios-de-inti-y-bryan'
                                     ]
                    },
                    {
                        medio: 'Willax TV',
                        logo: '/wp-content/interactivos/el-cartel-de-la-desinformacion/logos/willax.png',
                        desinformacion: 'La vacuna Sinopharm es agua destilada',
                        tema: 'Pandemia y Covid-19',
                        enlace: 'https://www.facebook.com/watch/?extid=SEO----&v=427110615186913&_rdc=1&_rdr',
                        fecha: '6/03/2021',
                        verificacion: [ 'https://repositorio.ulima.edu.pe/bitstream/handle/20.500.12724/15115/Asorsa_Fake%20news%20en%20la%20narrativa%20de%20Willax%20tv.%20Impacto%20social%20y%20desaf%C3%ADos.pdf']
                    },
                    {
                        medio: 'Piensa.pe',
                        logo: '/wp-content/interactivos/el-cartel-de-la-desinformacion/logos/piensape.png',
                        desinformacion: 'Hay evidencia estadística que cuestiona los resultados de la segunda vuelta electoral de 2021',
                        tema: 'Supuesto fraude en las elecciones de 2021',
                        enlace: 'https://www.facebook.com/watch/?v=854505531831003&_rdc=1&_rdr',
                        fecha: '25/06/2021',
                        verificacion: ['https://larepublica.pe/politica/2022/01/16/keiko-fujimori-archivan-otra-denuncia-de-fuerza-popular-sobre-supuestas-firmas-falsas-en-elecciones-2021',
                                        'https://youtu.be/rz9nIlJqc7E?si=3sZcOx-Iaz1ALCe7']
                    },
                    {
                        medio: 'Expreso',
                        logo: '/wp-content/interactivos/el-cartel-de-la-desinformacion/logos/expreso.png',
                        desinformacion: 'Observadores de la OEA no hicieron su labor en elecciones de 2021 y se fueron a tomar licor con Piero Corvetto',
                        tema: 'Rol de Piero Corvetto, jefe de la Oficina Nacional de Procesos Electorales (ONPE) y su rol en un supuesto fraude en las elecciones presidenciales de 2021',
                        enlace: 'https://plataforma.ipnoticias.com/Landing?cac=9xeJexyvgDgRGQAAkt4JJA%3d%3d&i=8rjVc38Q1fmQN9n3eazhjw%3d%3d&c=XBfoW5sLXiF%2bT7Ih1QJa4CcgOj4jiZjKnhkOrvkPo7oZaNnW7WxX4z9HBtStrDAq&pm=4Jpq4%2bSL9MeYY%2fsQdZtKaQ%3d%3d&idi=es',
                        fecha: '13/05/2022',
                        verificacion: ['https://www.parlamentomercosur.org/innovaportal/file/22099/1/peru---informe-final-de-la-mision-de-observacion-electoral-en-las-elecciones-generales-y-de-segunda-vuelta-de-la-republica-del-peru-2021.pdf']
                    },
                    {
                        medio: 'Expreso',
                        logo: '/wp-content/interactivos/el-cartel-de-la-desinformacion/logos/expreso.png',
                        desinformacion: 'La vacuna Sinopharm tiene 73 efectos adversos',
                        tema: 'Pandemia y Covid-19',
                        enlace: 'https://www.expreso.com.pe/opinion/los-73-efectos-adversos-de-la-vacuna-sinopharm/',
                        fecha: '25/02/2021',
                        verificacion: ['https://www.globaltimes.cn/page/202101/1212084.shtml?fbclid=IwAR1PoFBJZYz-QSI0zUNO718vEs7pcvERssdaQxpNufSAjRzopWEbQ9megjc']
                    },
                    {
                        medio: 'Willax',
                        logo: '/wp-content/interactivos/el-cartel-de-la-desinformacion/logos/willax.png',
                        desinformacion: 'Admisión de Jorge Barata de conocer a Gustavo Gorriti, de IDL-Reporteros, implicaría algún tipo de coordinación o vínculo sospechoso entre ambos',
                        tema: 'Supuesta coordinación entre Jorge Barata, ex director ejecutivo de Odebrecht en Perú (2011-2016) con Gustavo Gorriti, director de IDL-Reporteros',
                        enlace: 'https://willax.pe/politica/jorge-barata-confiesa-conocer-a-gustavo-mohme-y-gustavo-gorriti',
                        fecha: '27/04/2023',
                        verificacion: ['https://www.youtube.com/watch?v=PYetoESxMng']
                    },
                    {
                        medio: 'Willax',
                        logo: '/wp-content/interactivos/el-cartel-de-la-desinformacion/logos/willax.png',
                        desinformacion: 'El desbalance patrimonial del fiscal José Domingo Pérez ascendería a más de 137 mil dólares ',
                        tema: 'Supuesto desbalance patrimonial de José Domingo Pérez, fiscal titular de la Primera Fiscalía Provincial Corporativa Especializada en Delitos de Corrupción de Funcionarios de Lima',
                        enlace: 'https://willax.pe/politica/jose-domingo-perez-entre-los-anos-2018-y-2023-fiscal-lava-jato-presenta-desbalance-patrimonial-de-131-mil-soles',
                        fecha: '23/09/2024',
                        verificacion: ['https://epicentro.tv/la-pericia-no-hace-ninguna-observacion-a-la-adquisicion-de-mi-vehiculo/']
                    },
                    {
                        medio: 'Expreso',
                        logo: '/wp-content/interactivos/el-cartel-de-la-desinformacion/logos/expreso.png',
                        desinformacion: 'Supuestos chats de Paola Ugaz confirmarían que esta habría lavado dinero',
                        tema: 'Paola Ugaz y supuesto lavado de dinero',
                        enlace: 'https://www.expreso.com.pe/destacado-portada/los-chats-de-paola-ugaz/623453/',
                        fecha: '3/09/2020',
                        verificacion: ['https://www.swissinfo.ch/spa/la-fiscal%C3%ADa-de-per%C3%BA-archiva-denuncia-contra-periodista-que-investig%C3%B3-el-caso-sodalicio/48859802']
                    },
                    {
                        medio: 'Willax',
                        logo: '/wp-content/interactivos/el-cartel-de-la-desinformacion/logos/willax.png',
                        desinformacion: 'La congresista Sigrid Bazán habria pagado su departamento con 330 mil dólares cuyo origen no tiene cómo explicar',
                        tema: 'Sigrid Bazán y supuesta compra irregular de un departamento',
                        enlace: 'https://youtu.be/zSe5hEgLMbs?si=t-diFwyv0rU4V1Is',
                        fecha: '7/05/2023',
                        verificacion: ['https://tinyurl.com/CasoSigridElFoco']
                    },
                    // Agrega más elementos según sea necesario
                ]
            };
        }
}

</script>